import { apiClient } from "@/api/modules/base.ts";
import {
    getCustomNutritionStatementById, Route,
} from "./routes.ts";
import type { AxiosPromise } from "axios";
import type {
    CustomNutritionStatementBase,
    CustomNutritionStatementCreateRequest,
    CustomNutritionStatementCreateResponse,
    CustomNutritionStatementShowResponse
} from "@/api/modules/autoQ/customNutritionStatements/types.ts";

export const showCustomNutritionStatement = (customNutritionStatementId: number): AxiosPromise<CustomNutritionStatementShowResponse> =>
    apiClient.get(getCustomNutritionStatementById(customNutritionStatementId));

export const createCustomNutritionStatement = (payload: CustomNutritionStatementCreateRequest): AxiosPromise<CustomNutritionStatementCreateResponse> =>
    apiClient.post(Route.CustomNutritionStatements, payload);

export const deleteCustomNutritionStatement = (customNutritionStatementId: number): AxiosPromise<void> =>
    apiClient.delete(getCustomNutritionStatementById(customNutritionStatementId));

export const updateCustomNutritionStatement = (customNutritionStatementId: number, payload: Partial<CustomNutritionStatementBase>): AxiosPromise<void> =>
    apiClient.patch(getCustomNutritionStatementById(customNutritionStatementId), payload);